import type { OriginalItemTypes } from "./types";

export type SubskillAssessment = {
	key?: string;
	name?: string;
	score?: number;
	displayScore?: number;
	maxScore?: number;
	normalizedScore?: number;
	multiplier?: number;
};

export type AssessmentRunStatus = "PENDING" | "COMPLETE";

export type AIFeedbackResponse = {
	explanation?: string;
	transcription?: string;
	subskillAssessments?: SubskillAssessment[];
	score?: number;
	displayScore?: number;
	normalizedPoints?: number;
	runDetails?: {
		assistantId?: string;
		runId?: string;
		threadId?: string;
	};
	feedback?: string;
	rating?: string;
	itemType: OriginalItemTypes;
	retries?: number;
	answer?: string;
	status?: AssessmentRunStatus;
};

export type AIResponsePayload = {
	feedback: string;
	subskillAssessments: SubskillAssessment[];
	ai_run_id: string;
	ai_thread_id: string;
	metadata: {
		assistantId: string;
	};
	answer?: string;
	status?: AssessmentRunStatus;
};
